import React from "react";
import Div from "../../../../widget/common/ui/Div";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { ProfileDetails } from "../../../../model/settings/SettingsPersonalInfoModel";
import { textCase } from "../../../../service/ui/UI";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";

const SettingsProfile = (props: {
  type?: number | undefined;
  profileInfo: ProfileDetails | null;
}) => {
  const profileInfo: ProfileDetails | null = props.profileInfo ?? null;

  const onClickEdit = () => {
    navigate(appRoutes.routeNameSettingsPeronalInfo);
  };

  return (
    <>
      {profileInfo != null && (
        <Div color="theme-font" fontSize="16_17">
          <div
            className="bgcolor-primary p-2 p-lg-3  theme-radius d-grid "
            style={{ gridTemplateColumns: `1fr 80px` }}
            role="button"
            onClick={() => onClickEdit()}
          >
            <Div className="d-flex pe-2 align-items-center">
              <Div className="me-3">
                <LogoRound
                  url={profileInfo?.logo_details?.file_url!}
                  isProfile={true}
                  name={`${profileInfo.first_name!} ${profileInfo.last_name!}`}
                  size={50}
                />
              </Div>
              <TextBlock
                textColor="theme-font"
                fontSize="16_17"
                fontName="medium"
              >
                {textCase(
                  `${profileInfo.first_name!} ${profileInfo.last_name}`
                )}
              </TextBlock>
            </Div>
            <Div className="d-flex align-items-center justify-content-end">
              <Div>
                <Div className="d-flex align-items-center justify-content-end pb-1">
                  <IconNormal size={15} name="edit" color="color-theme-font" />
                </Div>
                <TextBlock
                  fontName="book"
                  fontSize="10_12"
                  textColor="theme-font"
                >
                  {AppTranslation.text("edit_account")}
                </TextBlock>
              </Div>
            </Div>
          </div>
        </Div>
      )}
    </>
  );
};

export default SettingsProfile;
